import 'apps/hiring/styles/components/applicant/target-content.scss';
import React from 'react';
import { bool, func, number, object, oneOfType, shape, string } from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import { strip_tags } from 'library/helpers/text';
import CheckIcon from 'library/icons/check.svg';
import CloseIcon from 'library/icons/close.svg';

class TargetSlice extends React.Component {
  static propTypes = {
    id: number,
    percentile_range: shape({
      start: number,
      end: number
    }),
    characteristic: object,
    range: oneOfType([number, string]),
    active: bool,
    toggleActive: func
  }

  render() {
    const {
      id,
      percentile_range,
      characteristic,
      range,
      active,
      toggleActive
    } = this.props;

    return (
      <div
        className={['cheese-slice hiring-application-target-cheese', active?'active':null].filter(c=>c).join(' ')}
        onClick={toggleActive}
        data-id={id}
      >
        <div className="hiring-application-target-cheese-wrapper">
          <div data-range={range||'medium'} className="hiring-application-target-cheese-background" />
          <div className="cheese-slice-chart">
            <div className="cheese-slice-chart-range" style={{left: `${percentile_range.start}%`, right: `${100-percentile_range.end}%`}} />
            <div
              style={{left: `${characteristic.score}%`}}
              className="cheese-slice-chart-score"
            />
          </div>
          <div className="hiring-application-target-cheese-overlay">
            {
              (new Array(11)).fill(null).map((v,i)=>(
                <div key={i} className="hiring-application-target-cheese-overlay-line">
                  { (i*10) - 50 }
                </div>
              ))
            }
            <div className="hiring-application-target-cheese-overlay-label">
              Less
            </div>
            <div className="hiring-application-target-cheese-overlay-label">
              Moderate
            </div>
            <div className="hiring-application-target-cheese-overlay-label">
              More
            </div>
          </div>
        </div>
        <div data-tooltip={strip_tags(resolve(characteristic, 'description', ''))} className="cheese-slice-data">
          <span>
            { resolve(characteristic, 'name', '') }
          </span>
        </div>
        <div className="cheese-slice-data">
          <span>
            { resolve(characteristic, 'score', 0) }
          </span>
        </div>
        <div className="cheese-slice-data">
          <span>
            {
              (Number(resolve(characteristic, 'score', 0)) <= percentile_range.end
              && Number(resolve(characteristic, 'score', 0)) >= percentile_range.start)
                ? (
                  <CheckIcon style={{width: '1em', height: '1em'}} />
                )
                : (
                  Number(resolve(characteristic, 'score', 0)) > percentile_range.end
                    ? `+${Number(resolve(characteristic, 'score', 0)) - percentile_range.end }`
                    : `${Number(resolve(characteristic, 'score', 0)) - percentile_range.start}`
                )
            }
          </span>
        </div>
      </div>
    );
  }
}

export default TargetSlice;
